import React from 'react';

// Previously fetched today's top scores from daily_scores via ../lib/supabaseClient.
// Re-wire that client when ready to restore the live leaderboard.

const Leaderboard = () => {
  return (
    <div className="max-w-md mx-auto text-center">
      <h2 className="text-2xl font-bold mb-4">Today's Daily Challenge Leaderboard</h2>
      <p className="text-gray-600 dark:text-gray-300">Coming soon</p>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
        Shared daily rankings will return here once we have enough players.
      </p>
    </div>
  );
};

export default Leaderboard;
